<div class="product-list">
  @if (!isPoh && componentData.title && componentData.title.length > 0) {
    <div class="product-list__title text-center">
      <h1>{{ componentData.title }}</h1>
    </div>
  }

  <div class="product-list__container container">
    @if (!isPoh) {
      <div class="product-list__filters-top">
        <div class="product-list__filters-show show-filters__container">
          @if (showFilters) {
            <button type="button" class="show-filters__button ng-scope" (click)="isFilterOpen = !isFilterOpen">
              <picture class="show-filters__icon">
                @if (isFilterOpen) {
                  <img alt="Close Icon" title="Close" [src]="'assets/images/close.svg' | staticFileHash" />
                } @else {
                  <img alt="Filter Icon" title="Filter" [src]="'assets/images/filters.svg' | staticFileHash" />
                }
              </picture>
              <span class="show-filters__text" i18n="@@FILTERS">Filters</span>
            </button>
          }
        </div>
        <div class="product-list__count">
          <span>{{ totalProducts }}</span>
          <span i18n="@@TOTAL_PRODUCTS">{totalProducts, plural, =1 {Product} other {Products}}</span>
        </div>
      </div>
    }

    <div class="product-list__products row">
      @if (!isPoh && showFilters) {
        <div class="product-list__filters-container col-lg-4 col-md-6 col-sm-6 col-12" [ngClass]="{ open: isFilterOpen }">
          <div class="product-list__filters-wrapper">
            <app-filter [filterCriteria]="'all'" [categoryId]="componentData.feedId" [aggregations]="aggregations" />
          </div>
        </div>
      }
      <div class="product-list__products-container" [ngClass]="{ 'col-lg-8 col-md-6 col-sm-6 col-12': isFilterOpen }">
        <app-product-list
          [products]="productList"
          [metaproducts]="metaproductsRequested"
          [isInWishlist]="isInWishlist"
          [isFilterOpen]="isFilterOpen"
          [productRequested]="productRequested"
          [colorReferences]="colorReferences"
          [displaySpecificProductCampaignHighlights]="true"
          (getProductById)="onGetProductById($event)"
          (addToWishlistEvent)="addToWishlistEventHandler()"
          (removeFromWishlistEvent)="removeFromWishlistEventHandler()"
          (setWishlistedProductEvent)="setWishlistedProductEventHandler($event)"
          (checkLoggedUserEvent)="checkLoggedUserEventHandler()"
          (getMetaproductsEventHandler)="getMetaproducts($event)"
        />
      </div>
    </div>
  </div>

  <app-pagination
    [paginationType]="'loadMore'"
    [currentPage]="currentOffset"
    [showNextPage]="showNextPage"
    [showLoadMore]="showLoadMore"
    (previousPageEvent)="previousPageEventHandler()"
    (nextPageEvent)="nextPageEventHandler()"
    (loadMoreEvent)="loadMoreEventHandler()"
  />
</div>
